/*
课程笔记组件 笔记列表的展示
courseInfo: 课程详情数据
*/

<template>
  <div class="note_pane">
    <div class="all_txt">
      全部笔记&nbsp;{{ notePage.totalCount }}
    </div>
    <div class="note_list">
      <div
        v-for="(note, index) in opts.noteList"
        :key="index"
        class="note_item"
      >
        <div class="note_cover">
          <el-avatar
            :size="48"
            :src="note.headImg"
            class="note_img"
          />
        </div>
        <div class="note_info">
          <div class="note_info_header">
            <span class="note_info_name tx-ov">{{ note.userName }}</span>
            <span class="note_info_time">{{ note.gmtCreate }}</span>
          </div>
          <div
            :class="{ 'tx-ov-2': !note.showChild, mgb30: !note.pic }"
            class="note_info_content"
          >
            {{ note.content }}
          </div>
          <el-button
            v-if="note.content.length > 153"
            type="text"
            @click="note.showChild = !note.showChild"
          >
            {{ note.showChild ? "收起" : "展开" }}
          </el-button>
          <div
            v-if="note.pic"
            class="pic"
          >
            <el-image
              v-for="(pic, index) in (note.pic?.split(',') || [])"
              :key="index"
              :src="pic"
              :preview-teleported="true"
              :preview-src-list="[pic]"
              fit="cover"
            />
          </div>
        </div>
      </div>
      <div class="loading_btn">
        <el-button
          v-if="notePage.totalPage > notePage.pageCurrent && !opts.note"
          type="text"
          @click="handleScroll"
        >
          查看更多
        </el-button>
        <span
          v-if="opts.note"
          class="loading_text"
        >加载中...</span>
        <span
          v-if="notePage.totalPage <= notePage.pageCurrent && !opts.note"
          class="loading_text"
        >已经到底部，没有更多内容了</span>
      </div>
    </div>
  </div>

</template>

<script>

import { courseAuthNotesListData, courseNotesListData } from '../../api/course'
import { useUserStore } from '@/stores/user'

export default {
  name: 'CourseNotes',
  components: {},
  props: {
    // 课程详情数据
    courseInfo: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  setup (props, { emit }) {
    const userStore = useUserStore()
    const { getToken } = userStore
    const token = computed(() => {
      return getToken()
    })
    const { courseInfo } = toRefs(props)
    const opts = reactive({
      note: false,
      noteList: []
    })
    const notePage = reactive({
      pageCurrent: 1,
      pageSize: 10,
      totalPage: 1,
      totalCount: 0
    })

    const handleScroll = () => {
      // 滚动到底翻页
      if (notePage.totalPage > notePage.pageCurrent) {
        notePage.pageCurrent++
        getNotes()
      }
    }
    // 笔记列表
    const getNotes = () => {
      opts.note = true
      if (token.value) {
        courseAuthNotesListData(
          { courseId: courseInfo.value.id },
          notePage.pageCurrent,
          notePage.pageSize
        ).then((res) => {
          opts.note = false
          if (notePage.pageCurrent === 1) {
            opts.noteList = res.list || []
          } else {
            res.list = res.list || []
            res.list.forEach((el) => {
              opts.noteList.push(el)
            })
          }
          notePage.pageCurrent = res.pageCurrent
          notePage.totalPage = res.totalPage
          notePage.totalCount = res.totalCount
        }).catch(() => {
          opts.note = false
        })
      } else {
        courseNotesListData(
          { courseId: courseInfo.value.id },
          notePage.pageCurrent,
          notePage.pageSize
        ).then((res) => {
          opts.note = false
          if (notePage.pageCurrent === 1) {
            opts.noteList = res.list || []
          } else {
            res.list = res.list || []
            res.list.forEach((el) => {
              opts.noteList.push(el)
            })
          }
          notePage.pageCurrent = res.pageCurrent
          notePage.totalPage = res.totalPage
          notePage.totalCount = res.totalCount
        }).catch(() => {
          opts.note = false
        })
      }
    }
    onMounted(() => {
      getNotes()
    })
    return {
      opts,
      notePage,
      courseInfo,
      handleScroll
    }
  }
}
</script>

<style scoped lang="scss">


.all_txt {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #333333;
  margin-bottom: 20px;
}

.note_pane {
  padding-top: 20px;
}
.note_item {
  display: flex;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;

  & + .note_item {
    padding-top: 20px;
  }
}

.note_cover {
  margin-right: 20px;
}

.note_info {
  width: calc(100% - 68px);
}
.pic {
  margin: 10px 0;
  display: flex;
  flex-wrap: wrap;
  .el-image {
    width: 144px;
    height: 80px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

.flex_note_img {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.note_bg_img {
  width: 144px;
  margin-bottom: 10px;
}

.note_info_header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .note_info_name {
    font-style: normal;
    font-weight: 550;
    font-size: 16px;
  }

  .note_info_time {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #999999;
  }
}

.loading_btn {
  text-align: center;
  padding-top: 11px;
  padding-bottom: 11px;
  margin-top: 20px;

  .loading_text {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: #999999;
  }
}
</style>
